import { Card, IGuiBinder, Index } from '@synqo/frontend-component-library';
import { useRemarks } from './useRemarks';

interface IRemarksProps<T> {
    data: T;
    remarkTypes: [Index<T>, string][];
    canEdit: boolean;

    binder: IGuiBinder<T>;
}

export function RemarksCard<T>({ remarkTypes, data, canEdit, binder }: IRemarksProps<T>) {
    const { hasRemarks, addRemarkMenu, remarkInputs } = useRemarks({
        remarkTypes,
        data,
        canEdit,
        binder,
        menuClassName: 'ml-1',
    });

    if (!canEdit && !hasRemarks) {
        return undefined;
    }

    return (
        <Card
            name="remarks"
            key="remarks"
            label={'Bemerkung'}
            collapsable={hasRemarks}
            additionalHeaderAlignment={'left'}
            additionalHeaderOptions={addRemarkMenu}
        >
            {remarkInputs}
        </Card>
    );
}
